import React, { useMemo } from 'react';
import { getPageStaticProps } from 'lib/dato-request';
import Hero from 'components/Research/Hero';
import ResearchContentBlock from 'components/Research/ResearchContentBlock';
import BlockScrollBannerSelect from 'components/Research/BlockScrollBannerSelect';
import SecondaryPageLayout from '@/components/ReusableUI/SecondaryPageLayout';

const Research = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    const blocks = components[1].researchBlocks;

    const sections = useMemo(() => {
        return blocks.map((block) => (
            <ResearchContentBlock
                key={block?.title}
                heading={block?.title}
                kicker={block.kicker}
                img={block.featuredImage}
                content={block.content}
            />
        ));
    }, [blocks]);

    return (
        <SecondaryPageLayout page={page} components={[components[2], components[3]]}>
            <Hero
                heading={components[0].heading}
                subhead={components[0].subhead}
                ctalabel={components[0].ctalabel}
                ctalink={components[0].ctalink ?? '/signup'}
                img={components[0].featuredImage}
            />

            <BlockScrollBannerSelect blockData={blocks} />

            {sections}

        </SecondaryPageLayout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('Research');
}

export default Research;
